import { render, staticRenderFns } from "./CommonPagination.vue?vue&type=template&id=62d6e46a&scoped=true"
import script from "./CommonPagination.vue?vue&type=script&lang=js"
export * from "./CommonPagination.vue?vue&type=script&lang=js"
import style0 from "./CommonPagination.vue?vue&type=style&index=0&id=62d6e46a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6e46a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d6e46a')) {
      api.createRecord('62d6e46a', component.options)
    } else {
      api.reload('62d6e46a', component.options)
    }
    module.hot.accept("./CommonPagination.vue?vue&type=template&id=62d6e46a&scoped=true", function () {
      api.rerender('62d6e46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/CommonPagination.vue"
export default component.exports